module.exports = __webpack_public_path__ + "static/img/7037e9610f04a57932e8c6b9e5b86d8d.index3.1709800931122.png";